import { HomePageSettings } from 'app/home/index.functions';
import { Box, Stack } from '@mui/material';
import styles from './styles';
import React from 'react';
import { useThumbnailLoader } from 'app/home/useThumbnailLoader';
import { ITileInfoHeader } from '../types';
import IconMi from 'components/common/icon/IconMi';

export default function InfoHeader({
    tile,
    settings,
    isListView,
}: {
    tile: ITileInfoHeader;
    settings?: HomePageSettings;
    isListView?: boolean;
}) {
    const thumbnailLoader = useThumbnailLoader();

    const showTooltipThumbnail =
        isListView &&
        undefined !== settings?.theme?.catalog_list_column_count &&
        settings?.theme?.catalog_list_column_count > 1 &&
        settings?.theme?.catalog_list_display_thumbnail === 'Y';

    const header =
        tile.hide_mtf !== 'Y' &&
        tile.last_measurement_time_formatted &&
        !('external report' === tile.element_type && 'level 1' === tile.supports_last_refreshed_check) ? (
            <Stack direction="row" sx={styles.sectionWrapper}>
                <Box sx={styles.iconHolder}>
                    <IconMi icon="calendar" sx={{ fontSize: '16px' }} />
                </Box>
                <Box>{tile.last_measurement_time_formatted}</Box>
            </Stack>
        ) : null;

    if (showTooltipThumbnail) {
        return (
            <Stack>
                <Box sx={{ width: '100%' }} display={'flex'} justifyContent={'center'}>
                    <Box sx={styles.previewHolder}>
                        <img
                            src={thumbnailLoader.getImage(
                                tile.user_dashboard_element_instance_id || '',
                                tile.element_type,
                            )}
                            className={'tileThumb thumbnail_' + tile!.user_dashboard_element_instance_id}
                            style={{ width: '100%', height: '100%' }}
                        />
                    </Box>
                </Box>
                {header}
            </Stack>
        );
    }

    return header;
}
